import type { DemoItem, LibraryDoc, Collaborator, TemplateDoc, ArchiveDoc } from './types';
export const MOCK_ITEMS: DemoItem[] = [
  { id: '1', name: 'Demo Item A', value: 42 },
  { id: '2', name: 'Demo Item B', value: 73 }
];
export const MOCK_TEMPLATES: TemplateDoc[] = [
  {
    id: 't1',
    title: 'Standard NDA',
    description: 'Non-disclosure agreement for intellectual property protection.',
    category: 'Legal',
    snippet: 'This Confidentiality Agreement is entered into as of the date of signing...'
  },
  {
    id: 't2',
    title: 'Master Service Agreement',
    description: 'Foundation for long-term consulting and freelance relationships.',
    category: 'Legal',
    snippet: 'The Provider shall perform services as described in the Statement of Work...'
  },
  {
    id: 't3',
    title: 'Executive Briefing',
    description: 'A high-impact summary for board-level decision making.',
    category: 'Business',
    snippet: 'This memorandum outlines the strategic pivot for Q4 operations...'
  },
  {
    id: 't4',
    title: 'Academic Thesis Draft',
    description: 'Structured layout for rigorous research and citations.',
    category: 'Academic',
    snippet: 'In this paper, we examine the convergence of digital ethics and design...'
  }
];
export const MOCK_ARCHIVES: ArchiveDoc[] = [
  {
    id: 'a1',
    title: 'The Foundations of Synthetic Governance',
    author: 'Dr. Aris Thorne',
    date: 'Jan 14, 2024',
    price: '$29.00',
    type: 'Treatise',
    tags: ['Policy', 'AI']
  },
  {
    id: 'a2',
    title: 'Observations on Algorithmic Bias',
    author: 'Elena Casale',
    date: 'Dec 02, 2023',
    price: '$19.00',
    type: 'Whitepaper',
    tags: ['Ethics', 'Data']
  },
  {
    id: 'a3',
    title: 'The Mechanics of Modern Minimalism',
    author: 'Marcus Vane',
    date: 'Nov 15, 2023',
    price: '$45.00',
    type: 'Journal',
    tags: ['Design', 'Architecture']
  }
];
export const MOCK_LIBRARY_DOCS: LibraryDoc[] = [
  {
    id: '1',
    title: 'Silence: A Study in Minimalist Architecture',
    author: 'Elena Thorne',
    snippet: 'The void is not an absence, but a presence of potential. In the corridors of the modern museum...',
    date: 'Oct 12, 2023'
  },
  {
    id: '2',
    title: 'The Brutalist Manifesto',
    author: 'Marcus Vane',
    snippet: 'Raw concrete is the truth of our age. We do not hide behind plaster; we reveal the skeleton of our intent...',
    date: 'Sep 28, 2023'
  },
  {
    id: '3',
    title: 'Typography as Cartography',
    author: 'Sarah Chen',
    snippet: 'Every serif is a landmark, every baseline a horizon. To read is to travel through the landscape of thought...',
    date: 'Aug 15, 2023'
  }
];
export const MOCK_COLLABORATORS: Collaborator[] = [
  {
    id: '1',
    name: 'Julian Casablancas',
    email: 'julian@docforge.ai',
    avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?q=80&w=100&auto=format&fit=crop',
    role: 'Author',
    status: 'Active'
  },
  {
    id: '2',
    name: 'Amelie Poulain',
    email: 'amelie@docforge.ai',
    avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=80&w=100&auto=format&fit=crop',
    role: 'Editor',
    status: 'Active'
  },
  {
    id: '3',
    name: 'Dorian Gray',
    email: 'dorian@docforge.ai',
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?q=80&w=100&auto=format&fit=crop',
    role: 'Viewer',
    status: 'Pending'
  }
];